 import PulseLoader from "react-spinners/PulseLoader";

export default function Index({ spin, children, color, size }: {
    spin?: boolean,
    children: any,
    color?: string,
    size?: string
}) {

    if (spin) {
        return <PulseLoader color={color || "#5B6872"}
            size={size || ".1rem"}
            speedMultiplier={0.5} />
    } else {
        return <>
            {children}
        </>
    }

}